module.exports = ".ui-fileupload .ui-corner-top {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n.ui-fileupload .ui-corner-bottom {\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.ui-fileupload .ui-button {\n  border-radius: 2px;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/primeng/file-upload/css/primeng.file-upload.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/primeng/file-upload/css/primeng.file-upload.css
// module chunks = styles